<template>
  <div ref="StackedLineMain" class="card-iphone" :class="type !== 'MSC' ? 'card' : 'card-MSC'" :style="style">
    <div ref="headerChart" class="card-header bg-gray-light border-0 pb-1">
      <h3 class="card-title font-weight-bolder">
        <i class="fas fa-th mr-1"></i>
        <v-tooltip top>
          <span class="justify-content-end align-content-end" style="font-size: 1.2rem">{{ title }}</span>
          <template v-slot:activator="{ on }">
            <span style="font-weight: 600;" v-if="title !== undefined && title !== null && title.length > 50">...</span>
            <span style="font-weight: 600;" v-on="on">{{ (title !== undefined && title !== null) ? title.slice(0, 50) :
            "" }}</span>
          </template>
        </v-tooltip>
      </h3>

      <div class="card-tools mb-2 ml-auto">
        <button class="btn bg-btn-card-tool btn-sm mx-2" type="button" v-on:click.prevent="handleOpenDialogSafieCamera"
          v-if="!isGuestSite && isDashboard && type !== 'MWC'">
          <v-icon dark>mdi-login</v-icon>
        </button>
        <button v-if="!isGuestSite && (link !== undefined || type === 'MWC') && type !== 'MSC' && isDashboard" v-on:click="openInNewWindow('MWC')" type="button"
          class="btn bg-btn-card-tool btn-sm">
          <v-icon dark>mdi-desktop-mac</v-icon>
        </button>
        <button v-if="!isGuestSite && (link !== undefined || type === 'MSC') && type !== 'MWC' && isDashboard" v-on:click="openInNewWindow('MSC')" type="button"
          class="btn bg-btn-card-tool btn-sm">
          <v-icon dark>mdi-desktop-mac</v-icon>
        </button>
        <button v-if="isShowEdit" type="button" class="btn btn-sm" @click="clickClose">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div ref="cardBody" class="card-body" style="position: relative;">
        <!-- <safie-streaming-player :style="style" style="width: 100%; position: absolute;" ref="safieVideo" v-if="type !== 'MWC' && safieVideos.length == 0"></safie-streaming-player> -->
        <div class="safieStyle" style="width: 100%; position: absolute; height: auto !important;"  v-if="type !== 'MWC' && safieVideos.length == 0">
          <div class="image-container">
            <div class="image-container">
              <img src="../../assets/img/safieImage.png" alt="">
            </div>
          </div>
          <p class="titleSafie">右上にある<button class="btn bg-btn-card-tool btn-sm mx-2">
            <v-icon dark>mdi-login</v-icon>
          </button>アイコンをクリックしてください。</p>
          <p>認証画面が表示されます。Safieカメラに登録されているメールアドレスとパスワードを入力して認証ください。</p>
        </div>
       <div v-if="type !== 'MWC' && safieVideos.length > 0" style="width: 100%; position: absolute; height: auto !important;">
          <div v-for="(video, index) in safieVideos" :key="index">
            <video :style="{height: height - 120 + 'px'}" :ref="'video' + (index + 1)" controls autoplay muted></video>
            <p class="video-title">{{ video.deviceName }}</p>
          </div>
       </div>
       <div class="col-12 d-flex justify-content-center" v-if="type === 'MWC'" style="flex-basis: 0; flex-grow: 1">
          <iframe :src="`${linkUrl}/nphControlCamera?Direction=`" name="_cameraFrame" hidden></iframe>
          <div v-if="link !== undefined" :style="{width: iframeWidth}" style="min-height: 225px;" ref="mwcIframe">
            <iframe
                :src="`${linkUrl}/ImageViewer?Resolution=${iframeWidth}x${iframeHeight}&Quality=Standard&Mode=Motion&Interval=1`"
                scrolling="no"
                frameborder="yes"
                @load="iframeIsLoaded"
                style="overflow: hidden !important; width: 100% !important; height: 100%"
                id="frame">
            </iframe>
          </div>
          <div v-else style="width: 100%; max-height: 180px;" class="d-flex align-items-center justify-content-center">
            <img
                class="img-item"
                src="@/assets/img/camera_frame.png"
                style="max-width: 100%; max-height: 100%"
                id="frame"
                alt=""/>
          </div>
        </div>
        <div>
          <table class="table table-style" v-if="type === 'MWC'">
            <thead>
            <tr>
              <th scope="col" class="text-white" style="background-color: #3d76ad !important;">{{
                  $t("cameraFrame.action")
                }}
              </th>
              <th scope="col" class="text-white" style="background-color: #3d76ad !important;">{{
                  $t("cameraFrame.pan")
                }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr style="border-bottom: 1px solid #ebebeb">
              <td class="w-50">
                <div class="d-flex justify-content-center ">
                  <div class="''">
                    <div class="d-flex justify-content-center py-1">
                      <div class="hover-icon">
                        <v-btn v-on:click="handleZoomInOutOnly(1)" class="btn btn-sm btn-primary">
                          <font-awesome-icon
                            icon="fa-solid fa-magnifying-glass-plus"
                            :size="zoomIn"
                            @mouseover="zoomIn = 'lg'"
                            @mouseout="zoomIn = 'lg'"
                          />
                        </v-btn>

                      </div>
                      <div class="hover-icon">
                        <v-btn v-on:click="handleZoomInOutOnly(-1)" class="btn btn-sm btn-primary">
                          <font-awesome-icon
                            icon="fa-solid fa-magnifying-glass-minus"
                            :size="zoomOut"
                            @mouseover="zoomOut = 'lg'"
                            @mouseout="zoomOut = 'lg'"
                          />
                        </v-btn>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <div class="hover-icon">
                        <v-btn class="btn btn-sm btn-primary" v-on:click="handleCaptureScreen">
                          <font-awesome-icon icon="fa-solid fa-camera" size="lg"/>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="w-50">
                <div class="d-flex justify-content-center align-items-center button-group-ipad row p-0 m-0">
                  <div class="col-12 d-flex justify-content-center p-0 m-0 py-1">
                    <div class="hover-icon">
                      <v-btn v-on:click="handleZoomInOutCamera('TiltUp')" class="btn btn-sm btn-primary" size="sm">
                        <font-awesome-icon
                          icon="fa-solid fa-arrow-up"
                          size="lg"
                        />
                      </v-btn>
                    </div>
                  </div>
                  <div :class="checkWidth ? 'd-flex' : 'col-12 d-flex justify-content-center p-0 m-0'">
                    <div class="hover-icon">
                      <v-btn v-on:click="handleZoomInOutCamera('PanLeft')" class="btn btn-sm btn-primary"
                        size="sm">
                        <font-awesome-icon
                          icon="fa-solid fa-arrow-left"
                          size="lg"
                        />
                      </v-btn>
                    </div>
                    <div class="hover-icon">
                      <v-btn v-on:click="handleZoomInOutCamera('TiltDown')" class="btn btn-sm btn-primary" size="sm">
                        <font-awesome-icon
                          icon="fa-solid fa-arrow-down"
                          size="lg"
                        />
                      </v-btn>
                    </div>
                    <div class="hover-icon">
                      <v-btn v-on:click="handleZoomInOutCamera('PanRight')" class="btn btn-sm btn-primary"
                        size="sm">
                        <font-awesome-icon
                          icon="fa-solid fa-arrow-right"
                          size="lg"
                        />
                      </v-btn>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</template>

<script>
import { getSafieToken, getRoleID } from "@/utils/auth";
import { mapActions } from "vuex";
import Hls from 'hls.js';
import 'video.js/dist/video-js.css';
import { nextTick } from 'vue';
require("../../assets/js/safie");

export default {
  name: "MWC",
  components: {},
  props: {
    height: Number,
    width: Number,
    type: String,
    title: String,
    link: String,
    isShowEdit: Boolean,
    isResize: String,
    frameId: Number,
    isDashboard: Boolean
  },
  data() {
    return {
      signalRConnection: undefined,
      zoomIn: "lg",
      zoomOut: "lg",
      safieLink: null,
      showPassword: false,
      heightContainer: 0,
      loginCameraFlg: false,
      iframeWidth: 320,
      iframeHeight: 240,
      loginSafie: false,
      safieOrigin: "https://safie.link/",
      safieIframeSrc: "https://safie.link/swc/1.0.1/iframe.html",
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "application/x-mpegURL",
          src: "",
          withCredentials: false,
        }],
        controlBar: {
          timeDivider: false,
          durationDisplay: false
        },
        html5: {
          vhs: {
            withCredentials: true
          }
        },
      },
      player: null,
      checkWidth: true,
      segmentIndex: 0,
      mediaSource: null,
      sourceBuffer: null,
      videoUrl: null,
      streamUrl: null,
      safieVideos: [],
      hlsInstances: []

    };
  },
  async mounted() {
    window.addEventListener("message", async (event) => {
      if (event.data?.loggedIn) {
        // await this.getStreamUrlSafie();
        await this.updateDeviceStream();
        await nextTick();
        await this.playStreamVideo();
      }
    });
    if (getSafieToken() != undefined) {
      // await this.getStreamUrlSafie();
      await this.updateDeviceStream();
      await nextTick();
      await this.playStreamVideo();
      // await this.updateStreamUrlByDevice();
    }
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.setGridLayout();
    this.setWidth();
    this.$emit(`ChartReady`, this.frameId);
    this.signalRConnection = this.$dashboardHub.init();
    this.$dashboardHub.NotifySafieLogin(this.signalRConnection);
    this.setClassGroupButton()
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    this.cleanupHlsInstances();
  },
  watch: {
    width: {
      handler () {
       this.setClassGroupButton()
      }
    },
    async safieVideos() {
      // await this.playStreamVideo();
    }
  },
  computed: {
    style() {
      return "height: " + this.height + "px";
    },
    linkUrl() {
      if (this.link) {
        return this.link;
      } else {
        return "";
      }
    },
    login() {
      return this.loginSafe;
    },
    isGuestSite() {
        return getRoleID() == 4;
    }
  },
  methods: {
    ...mapActions("dashboard", {
      getSafieDevice: "getSafieDevice",
    }),
    ...mapActions("dashboard", {
      createStreamUrlSafie: "createStreamUrlSafie"
    }),
    setGridLayout() {
      const videoCount = this.safieVideos.length;
      const columns = Math.ceil(Math.sqrt(videoCount));
      this.$refs.cardBody.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
    },
    setWidth() {
      const mwcIframe = this.$refs?.mwcIframe;
      if (mwcIframe) {
        if (mwcIframe.clientHeight > 480) {
          mwcIframe.style.width = "640px";
          this.iframeWidth = 640;
          this.iframeHeight = 480;
        } else {
          mwcIframe.style.width = "320px";
          this.iframeWidth = 320;
          this.iframeHeight = 240;
        }
      }
    },
    setClassGroupButton () {
      if (this.width < 465) {
          this.checkWidth = false
        } else {
          this.checkWidth = true
        }
    },
    styleContainer() {
      return "height: " + this.heightContainer + "px";
    },
    getHeightContainer() {
      this.heightContainer = this.height - 58
      return this.heightContainer
    },
    iframeIsLoaded() {
      this.loginCameraFlg = true;
    },
    clickClose() {
      this.$emit(`closeFrame`, this.frameId);
    },
    openInNewWindow(cam) {
      let routeData = []
      let newWindow = null
      if (cam === 'MWC') {
          routeData = this.$router.resolve({
          path: '/camera',
          query: { link: this.linkUrl },
          append: true
        });
        newWindow = window.open(routeData.href, this.title,
          'width=800px,height=800px,toolbar=0,menubar=0,location=0');
      } else {
        routeData = 'https://safie.link/app/auth/login'
        newWindow = window.open(routeData);
      }
      if (window.focus) {
        newWindow.focus()
      }
    },
    handleZoomInOutCamera(flg) {
      let win = window.open(`${this.link}/nphControlCamera?Direction=${flg}&Resolution=640x480&Quality=Standard&RPeriod=0&Size=STD&PresetOperation=Move&Language=1`, '_cameraFrame');

      if (window.focus) {
        win.focus()
      }


    },
    handleZoomInOutOnly(flg) {
      let win = window.open(`${this.link}/cgi-bin/directctrl?zoom=${flg}&Language=1`, '_cameraFrame');

      if (window.focus) {
        win.focus()
      }


    },
    handleCaptureScreen() {
      let screen = window.open(`${this.link}/SnapshotJPEG?Resolution=800x600&Quality=Clarity&Language=1`);

      if (window.focus) {
        screen.focus()
      }
    },
    handleOpenDialogSafieCamera() {
      const adminPage = process.env.VUE_APP_SAFIE_PAGE;
      this.safieLink = `https://openapi.safie.link/v2/auth/authorize?client_id=5cf4b5083d05&response_type=code&scope=safie-api&redirect_uri=${adminPage}`
      let dialog = window.open(this.safieLink, "_blank", 'width=600px,height=600px,toolbar=0,menubar=0,location=0')
      if (window.focus) {
        dialog.focus()
      }
    },
    newGuid() {
      return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        const t = (16 * Math.random()) | 0;
        return ("x" === e ? t : (3 & t) | 8).toString(16);
      });
    },
    async updateDeviceStream() {
      const safieToken = getSafieToken();
      try {
        const response = await this.getSafieDevice(safieToken);
        // Tạo danh sách video từ phản hồi
        this.safieVideos = await Promise.all(response.data.list.map(async (x) => {
          const streamUrl = await this.getStreamUrlSafie(x.device_id);
          return {
            deviceId: x.device_id,
            deviceName: x.setting?.name,
            streamUrl: streamUrl || null
          };
        }));
        // this.safieVideos.push(this.safieVideos[0])
        // this.safieVideos.push(this.safieVideos[0])
        // this.safieVideos.push(this.safieVideos[0])
      } catch (error) {
        console.error("Lỗi khi cập nhật video:", error);
      }
    },

    async getStreamUrlSafie(deviceId) {
      try {
        const accessTokenSafie = getSafieToken();
        const streamUrlSafie = { deviceId, safieToken: accessTokenSafie };
        
        const response = await this.createStreamUrlSafie(streamUrlSafie);
        if (response.code === 0) {
          return response.data?.stream_url;
        } else {
          return null;
        }
      } catch (err) {
        if (err.code) {
          this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
        }
        return null;
      } finally {
        this.isSubmitAction = false;
      }
    },
    async playStreamVideo() {
      const baseUrl = process.env.VUE_APP_SERVICE_API;
      this.safieVideos.forEach((video, index) => {
        const streamUrl = encodeURIComponent(video.streamUrl);
        const videoUrl = `${baseUrl}Dashboard/streamSafie/${streamUrl}/${getSafieToken()}/playlist.m3u8`

        const videoElement = this.$refs[`video${index + 1}`][0];

        if (this.hlsInstances[index]) {
            this.hlsInstances[index].destroy();
        }

        if (Hls.isSupported()) {
          const hls = new Hls({
            liveSyncDurationCount: 2,
            startPosition: Hls.LiveSyncPosition,
            maxBufferLength: 10,
            maxMaxBufferLength: 15,
            liveBackBufferLength: 0,
          });
          hls.loadSource(videoUrl);
          hls.attachMedia(videoElement);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            videoElement.muted = true;
            videoElement.play().catch((error) => {
              console.error("Autoplay failed:", error);
            });
          });
          // Lưu instance vào mảng
          this.hlsInstances[index] = hls;
        } else if (videoElement.canPlayType('video/mp2t')) {
          videoElement.src = videoUrl;
          videoElement.muted = true;
          videoElement.addEventListener('loadedmetadata', () => {
            videoElement.play().catch((error) => {
              console.error("Autoplay failed:", error);
            });
          });
        } else {
          console.error("HLS is not supported on this browser.");
        }
      })
    },
    cleanupHlsInstances() {
      this.hlsInstances.forEach(hls => {
        if (hls) {
          hls.destroy();
        }
      });
      this.hlsInstances = [];
    },

    handleVisibilityChange() {
      if (!document.hidden) {
        this.cleanupHlsInstances();
        this.playStreamVideo(); // Gọi lại để tải video từ thời điểm mới nhất
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.safieStyle{
  font-family: Arial, sans-serif;
  text-align: center;
  background-color: white;
  color: #333;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  .titleSafie {
    font-size: 30px;
    color: #00a2ad;
    margin-bottom: 20px;
    font-weight: 700;
  }
  p {
    font-size: 14px;
    color: #666;
  }
  .image-container {
    margin: 20px 0;
  }
  .image-container img {
    width: 200px;
    height: auto;
  }
}
@media (max-width: 1180px) {
  .button-group-ipad {
    flex-direction: column;
  }

  .button-group {
    padding-top: 5% !important;
  }

  .hover-icon {
    padding-bottom: 10px;
  }
}

.button-group {
  padding-top: 9% !important;
}

.hidden-resizeable {
  display: none !important;
}

.card {
  height: 100% !important;
}
.card-MSC{
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.container {
  height: 100% !important;
}

.hover-icon:hover {
  color: red;
  cursor: pointer;
}

input[type="image"] {
  width: 480px;
  height: 320px;
}

.button-div {
  padding-top: 1%;
  padding-bottom: 1%;
}

.button-div-icon {
  padding-top: 12%;
}

.hover-icon {
  margin-right: 3px !important;
}

.img-item {
  padding: 5px 0;
}

.table-style {
  margin-top: 0;
  margin-bottom: 8px !important;
}

.table-height {
  height: 280px;
}
.bg-btn-card-tool{
  background-color: #3d76ad !important;
}

@media only screen and (max-width: 500px) and (max-height: 900px) and (orientation: portrait) {
  .normal-table table thead tr th {
    font-size: 0.75rem !important;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 28px;
    min-width: 40px;
  }
  .table {
    width: 300px !important;
  }
  // .card-body {
  //   overflow-x: auto;
  // }
}
.card-body {
  display: grid;
  gap: 10px; /* Adjust spacing as needed */
  overflow-x: auto;
}

video {
  width: 100%;
  object-fit: cover;
}
.video-title {
  text-align: start;
  margin: 10px 20px;
  font-size: 16px; 
  font-weight: bold;
  color: #333;
}
@media (min-width: 1286px) {
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
    margin-top: 0rem !important;
  }
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .card-MSC[data-v-c0f4d8c8] {
    margin-top: 0rem !important;
  }
}
@media (max-width: 1285px) {
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
    margin-top: 24rem !important;
  }
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .card-MSC[data-v-c0f4d8c8] {
    margin-top: 13rem !important;
  }
}
</style>
